import { render, staticRenderFns } from "./UM_repaymentList.vue?vue&type=template&id=bd512f2c&"
import script from "./UM_repaymentList.vue?vue&type=script&lang=js&"
export * from "./UM_repaymentList.vue?vue&type=script&lang=js&"
import style0 from "./UM_repaymentList.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports